/**
 * Vide — l'état vide (lot « surfaces », 01-11-2026) : « Aucun shift à venir dans ton planning »,
 * « Aucune vente sur la période ». Une icône en gris clair (pas dans un rond décoratif), un
 * titre, une phrase, et au plus une action. À la place des deux cents « Aucun… » écrits à la main.
 *
 *   <Vide icone={<Calendar />} titre="Aucun shift à venir" texte="Ton planning est libre cette semaine."
 *         action={<Button size="sm">Prendre un shift</Button>} />
 */
import type { ReactNode } from "react";

import { cn } from "./utils";
import "./surfaces.css";

export interface VideProps {
  titre: ReactNode;
  texte?: ReactNode;
  icone?: ReactNode;
  /** Un bouton, au plus. */
  action?: ReactNode;
  /** `sm` dans une petite carte ou une cellule. Défaut `md`. */
  taille?: "sm" | "md";
  className?: string;
}

export function Vide({ titre, texte, icone, action, taille = "md", className }: VideProps) {
  return (
    <div className={cn("sf-vide", className)} data-taille={taille} role="status">
      {icone !== undefined && icone !== null && (
        <span className="sf-vide-icone" aria-hidden>
          {icone}
        </span>
      )}
      <div className="sf-vide-titre">{titre}</div>
      {texte !== undefined && texte !== null && <div className="sf-vide-texte">{texte}</div>}
      {action && <div className="sf-vide-action">{action}</div>}
    </div>
  );
}
